const i = {
  switchStyles: {
    width: "36px",
    height: "17.5px",
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: "2px",
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(18px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#226A58",
          opacity: 1,
          border: 0
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5
        }
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: "#f7f7f7"
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7
      }
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: "13px",
      height: "13px"
    },
    "& .MuiSwitch-track": {
      borderRadius: "10px",
      backgroundColor: "#E9E9EA",
      opacity: 1
      // transition: theme.transitions.create(['background-color'], {
      //   duration: 500,
      // }),
    }
  },
  labelStyles: {
    gap: "6px"
  }
};
export {
  i as styles
};
